var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:[_vm.section, _vm.pointer],attrs:{"id":"app"}},[_c('Canvas'),_c('Header'),_c('Routes'),_c('Loader',{attrs:{"active":_vm.fetching}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }